import { defineMessages } from 'react-intl'

const scope = `procurify.modules.expense.features.correct-expense-item-account-code-inline.UseCorrectExpenseItemAccountCodeInlinePresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Expense item successfully updated.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to update expense item',
  },
})
